// Licensed from NativeLabs, an LR Ventures LLC FZ platform.
import { UNAUTHORIZED } from "constants/auth.constants";
import * as constants from "constants/wiki.constants";
import { combineReducers } from "redux";

const initialList = {
  loading: false,
  error: false,
  ready: false,
  pages: [],
  folders: [],
};

const listReducer = (state = initialList, action) => {
  switch (action.type) {
    case constants.PAGES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case constants.PAGES.FAILURE:
      return {
        ...state,
        pages: [],
        folders: [],
        loading: false,
        error: true,
        ready: false,
      };
    case constants.PAGES.SUCCESS: {
      const { pages, folders } = action.data;

      return {
        ...state,
        pages: pages || [],
        folders: folders || [],
        loading: false,
        error: false,
        ready: true,
      };
    }
    case UNAUTHORIZED:
      return initialList;
    default:
      return state;
  }
};

const initialPage = {
  loading: false,
  error: null,
  found: false,
  page: null,
};

const currentPageReducer = (state = initialPage, action) => {
  switch (action.type) {
    case constants.PAGE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.PAGE.FAILURE:
      return {
        ...state,
        loading: false,
        found: false,
        error: action.data,
      };
    case constants.PAGE.SUCCESS:
      return {
        ...state,
        page: action.data,
        found: true,
        loading: false,
        error: null,
      };
    case constants.PAGE_UPDATE.SUCCESS: {
      const page = action.data;

      if (!state.page || state.page.id !== page?.id) {
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          ...page,
        },
      };
    }
    case constants.PAGE_RESET:
      return initialPage;
    case UNAUTHORIZED:
      return initialPage;
    default:
      return state;
  }
};

const initialTrash = {
  loading: false,
  error: false,
  pages: [],
};

const trashReducer = (state = initialTrash, action) => {
  switch (action.type) {
    case constants.TRASH.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case constants.TRASH.FAILURE:
      return {
        ...state,
        pages: [],
        loading: false,
        error: true,
      };
    case constants.TRASH.SUCCESS: {
      const data = action.data;
      const pages = Array.isArray(data) ? data : data?.pages || [];

      return {
        ...state,
        pages,
        loading: false,
        error: false,
      };
    }
    case UNAUTHORIZED:
      return initialTrash;
    default:
      return state;
  }
};

const initialSearch = {
  loading: false,
  error: false,
  query: "",
  results: [],
};

const searchReducer = (state = initialSearch, action) => {
  switch (action.type) {
    case constants.SEARCH.REQUEST:
      return {
        ...state,
        query: action.data,
        loading: true,
      };
    case constants.SEARCH.FAILURE:
      return {
        ...state,
        results: [],
        loading: false,
        error: true,
      };
    case constants.SEARCH.SUCCESS: {
      const { results } = action.data;

      return {
        ...state,
        results: results || [],
        loading: false,
        error: false,
      };
    }
    case constants.SEARCH_RESET:
      return initialSearch;
    case UNAUTHORIZED:
      return initialSearch;
    default:
      return state;
  }
};

export default combineReducers({
  list: listReducer,
  current: currentPageReducer,
  trash: trashReducer,
  search: searchReducer,
});
